// import React, { Suspense } from "react";
// import { Routes, Route, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Helmet } from "react-helmet";

// import { useBookNowClearSessionOnNavigation } from "../components/BookNow/BookFormOne";
// import { useClearSessionOnNavigation } from "../components/Home/HomeContact";
// import { getMetaDetailList } from "../store/Slice/metaDetailsSlice";
// // import Preloader from "../components/Preloader/Preloader";
// import { Provider } from "react-redux";

// // import ChatbaseWidget from "../components/Common/ChatBaseWidget";
// import { store } from "../store/store";
// import ChatbaseWidget from "../components/Common/ChatBaseWidget";
// import ThankYouPage from "../pages/ThankYouPage";

// // const HomePage = React.lazy(() => import("../pages/HomePage"));
// import HomePage from "../pages/HomePage";
// import BlogDetailPage from "../pages/BlogDetailPage";

// import BlogPage from "../pages/BlogPage";
// import PasswordPrompt from "../components/PassWord/PasswordPrompt";
// import JobsWinnipegPage from "../pages/JobsWinnipegPage";
// import JobsOttawaPage from "../pages/JobsOttawaPage";
// import JobTorontoPage from "../pages/JobTorontoPage";
// import JobMississaugaPage from "../pages/JobMississaugaPage";
// import JobBramptonPage from "../pages/JobBramptonPage";
// import UpdateProfilePage from "../pages/UpdateProfilePage";
// import AddAddressPage from "../pages/AddAddressPage";
// import UpdateAddressPage from "../pages/UpdateAddressPage";
// import JobDetailPage from "../pages/JobDetailPage";
// import AddReviewPage from "../pages/AddReviewPage";
// import { setIsNotFound } from "../store/Slice/pageNotFoundSlice";

// import PostEventCleanupApp from "../components/MobileApp/Service-Detail/PostEventCleanupApp";
// import DeepCleaningApp from "../components/MobileApp/Service-Detail/DeepCleaningApp";
// import RoutineCleaningApp from "../components/MobileApp/Service-Detail/RoutineCleaningApp";
// import MoveInMoveOutApp from "../components/MobileApp/Service-Detail/MoveInMoveOutApp";
// import TermsConditionApp from "../components/MobileApp/TermsAndConditions/TermsConditionApp";
// import LandingPage from "../pages/LandingPage";

// const LoginPage = React.lazy(() => import("../pages/LoginPage"));
// const RegisterPage = React.lazy(() => import("../pages/RegisterPage"));
// const ContactPage = React.lazy(() => import("../pages/ContactPage"));
// const AboutUsPage = React.lazy(() => import("../pages/AboutUsPage"));
// const TermsOfUsePage = React.lazy(() => import("../pages/TermsOfUsePage"));
// const PrivacyPolicyPage = React.lazy(() =>
//   import("../pages/PrivacyPolicyPage")
// );
// const ProfilePage = React.lazy(() => import("../pages/ProfilePage"));
// const BookingPage = React.lazy(() => import("../pages/BookingPage"));
// const DashboardPage = React.lazy(() => import("../pages/DashboardPage"));
// const ChatPage = React.lazy(() => import("../pages/ChatPage"));
// const ChangePasswordPage = React.lazy(() =>
//   import("../pages/ChangePasswordPage")
// );
// const OrderPage = React.lazy(() => import("../pages/OrderPage"));
// const ReviewPage = React.lazy(() => import("../pages/ReviewPage"));
// const NotificationPage = React.lazy(() => import("../pages/NotificationPage"));
// const ForgetPasswordPage = React.lazy(() =>
//   import("../pages/ForgetPasswordPage")
// );
// const ResetPasswordPage = React.lazy(() =>
//   import("../pages/ResetPasswordPage")
// );
// const CheckAvailabilityForm = React.lazy(() =>
//   import("../pages/CheckAvailabilityForm")
// );
// const FaqPage = React.lazy(() => import("../pages/FaqPage"));
// const JoinNowPage = React.lazy(() => import("../pages/JoinNowPage"));
// const ContractorRegisterPage = React.lazy(() =>
//   import("../pages/ContractorRegisterPage")
// );

// const ServicesPage = React.lazy(() => import("../pages/ServicesPage"));
// const MoveInMoveOutPage = React.lazy(() =>
//   import("../pages/MoveInMoveOutPage")
// );
// const DeepCleansPage = React.lazy(() => import("../pages/DeepCleansPage"));
// const PostEventCleanupPage = React.lazy(() =>
//   import("../pages/PostEventCleanupPage")
// );
// const RoutineOneTimeCleaningPage = React.lazy(() =>
//   import("../pages/RoutineOneTimeCleaningPage")
// );
// const JobsPage = React.lazy(() => import("../pages/JobsPage"));
// const SuccessfullRegistrationPage = React.lazy(() =>
//   import("../pages/SuccessfullRegistrationPage")
// );
// const AccountActivationPage = React.lazy(() =>
//   import("../pages/AccountActivationPage")
// );
// const AccountVerifiedPage = React.lazy(() =>
//   import("../pages/AccountVerifiedPage")
// );
// const SuccessResetPasswordPage = React.lazy(() =>
//   import("../pages/SuccessResetPasswordPage")
// );
// const LogoutPage = React.lazy(() => import("../pages/LogoutPage"));
// const ServiceDetailPage = React.lazy(() =>
//   import("../pages/ServiceDetailPage")
// );
// const ErrorPage = React.lazy(() => import("../pages/ErrorPage"));
// const BookNowPage = React.lazy(() => import("../pages/BookNowPage"));

// const MapforceCommercialPage = React.lazy(() =>
//   import("../pages/MapforceCommercialPage")
// );
// const JobDescriptionPage = React.lazy(() =>
//   import("../pages/JobDescriptionPage")
// );
// const CareersPage = React.lazy(() => import("../pages/CareersPage"));
// const JobsCalgaryPage = React.lazy(() => import("../pages/JobsCalgaryPage"));
// const JobsLowerMainlandPage = React.lazy(() =>
//   import("../pages/JobsLowerMainlandPage")
// );
// const NotFoundPage = React.lazy(() => import("../pages/NotFoundPage"));

// function AppWrapper() {
//   return (
//     <Provider store={store}>
//       <Index />
//     </Provider>
//   );
// }

// const Index = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const [isPasswordCorrect, setIsPasswordCorrect] = React.useState(false);
//   const [isAuthChecked, setIsAuthChecked] = React.useState(false);

//   const { metaDetailData } = useSelector((state) => state.metaDetailList);

//   const pageUrlSlug =
//     location && location.pathname && location.pathname.split("/")[1];

//   const pathWithoutSlash = location && location.pathname.slice(1);

//   const vpath = location.pathname === "/" ? "Home" : pathWithoutSlash;

//   const formattedTitle = vpath.charAt(0).toLowerCase() + vpath.slice(1);

//   const path = location.pathname;
//   const blockedDomain = "mopforce.com";
//   // const blockedDomain = "localhost";
//   const currentDomain = window.location.hostname;

//   const normalizedDomain = currentDomain?.replace(/\/$/, "");
//   const normalizedBlockedDomain = blockedDomain?.replace(/\/$/, "");

//   const normalizedPath = path?.split("?")[0]?.replace(/\/$/, "");

//   const checkLiveDomain =
//     normalizedDomain === normalizedBlockedDomain &&
//     (normalizedPath === "/login" || normalizedPath === "/register");

//   React.useEffect(() => {
//     if (checkLiveDomain) {
//       dispatch(getMetaDetailList({ vSlug: "page-not-found" }));
//     } else {
//       dispatch(setIsNotFound(false)); // ensure reset on valid routes
//       dispatch(getMetaDetailList({ vSlug: pageUrlSlug || formattedTitle }));
//     }
//   }, [dispatch, pageUrlSlug, formattedTitle, checkLiveDomain]);

//   // React.useEffect(() => {
//   //   if (checkLiveDomain) {
//   //     dispatch(
//   //       getMetaDetailList({
//   //         vSlug: "data-not-found",
//   //       })
//   //     );
//   //   } else if (pageUrlSlug || formattedTitle) {
//   //     dispatch(
//   //       getMetaDetailList({
//   //         vSlug: pageUrlSlug || formattedTitle,
//   //       })
//   //     );
//   //   }
//   // }, [dispatch, pageUrlSlug, location, formattedTitle, checkLiveDomain]);

//   // React.useEffect(() => {
//   //   if (metaDetailData && metaDetailData.code === 200 && metaDetailData.data) {
//   //     setPageData(metaDetailData?.data);
//   //   }
//   // }, [metaDetailData]);

//   React.useEffect(() => {
//     if (location?.pathname === "/frequently-asked-questions") {
//     } else {
//       sessionStorage.removeItem("faqUserType");
//       sessionStorage.removeItem("viewAllButtonClick");
//     }
//   }, [location]);

//   const ScrollToTopOnRouteChange = () => {
//     React.useEffect(() => {
//       window.scrollTo(0, 0);
//     }, []);

//     return null;
//   };

//   useClearSessionOnNavigation();
//   useBookNowClearSessionOnNavigation();

//   React.useEffect(() => {
//     const isAuthenticated = sessionStorage.getItem("mopforce_auth");
//     if (isAuthenticated === "true") {
//       setIsPasswordCorrect(true);
//     }
//     setIsAuthChecked(true);
//   }, []);

//   const handlePasswordCorrect = (status) => {
//     if (status) {
//       sessionStorage.setItem("mopforce_auth", "true");
//     }
//     setIsPasswordCorrect(status);
//   };

//   if (!isAuthChecked) {
//     return null;
//   }

//   return (
//     <React.Fragment>
//       {!isPasswordCorrect && currentDomain === "mopforce.demo-available.com" ? (
//         <PasswordPrompt onPasswordCorrect={handlePasswordCorrect} />
//       ) : (
//         <>
//           <Helmet>
//             <title>
//               {metaDetailData?.data?.vTitle
//                 ? `${metaDetailData?.data?.vTitle} | MopForce`
//                 : "MopForce"}
//             </title>
//             <meta
//               name="description"
//               content={
//                 metaDetailData?.data?.tDescription ||
//                 "Professional cleaning services by MopForce."
//               }
//             />
//             <meta
//               name="keywords"
//               content={
//                 metaDetailData?.data?.tKeyword ||
//                 "cleaning, housekeeping, MopForce"
//               }
//             />
//             <meta
//               property="og:title"
//               content={
//                 metaDetailData?.data?.vTitle
//                   ? `${metaDetailData?.data?.vTitle} | MopForce`
//                   : "MopForce"
//               }
//             />
//             <meta
//               property="og:description"
//               content={
//                 metaDetailData?.data?.tDescription ||
//                 "Professional cleaning services by MopForce."
//               }
//             />
//             <meta property="og:url" content={window.location.href} />
//             <meta property="og:type" content="website" />
//           </Helmet>

//           <ScrollToTopOnRouteChange />

//           <ChatbaseWidget />

//           <Suspense
//             fallback={
//               null
//               // <div>Loading...</div>
//               //   <Preloader />
//             }
//           >
//             {checkLiveDomain ? (
//               <NotFoundPage />
//             ) : (
//               <Routes>
//                 <Route
//                   exact
//                   path="/"
//                   element={<HomePage />}
//                   title="Home-Page"
//                 />

//                 <Route
//                   exact
//                   path="/login"
//                   element={<LoginPage />}
//                   title="Login-Page"
//                 />

//                 <Route
//                   exact
//                   path="/register"
//                   element={<RegisterPage />}
//                   title="Register-Page"
//                 />

//                 {/* <Route
//                   exact
//                   path="/move-out-in-cleaning-edmonton"
//                   element={<LandingPage />}
//                   title="Landing-Page"
//                 /> */}

//                 <Route
//                   exact
//                   path="/:pageSlug"
//                   element={<LandingPage />}
//                 />

//                 <Route
//                   exact
//                   path="/contact-us"
//                   element={<ContactPage />}
//                   title="Contact-Us-Page"
//                 />
//                 <Route
//                   exact
//                   path="/about-us"
//                   element={<AboutUsPage />}
//                   title="About-Us-Page"
//                 />

//                 <Route
//                   exact
//                   path="/terms-and-conditions"
//                   element={<TermsOfUsePage />}
//                   title="Terms-and-Conditions-Page"
//                 />

//                 <Route
//                   exact
//                   path="/help-and-legal/terms-and-conditions"
//                   element={<TermsConditionApp />}
//                   title="Terms-and-Conditions-Page"
//                 />

//                 <Route
//                   exact
//                   path="/privacy-policy"
//                   element={<PrivacyPolicyPage />}
//                   title="Privacy-Policy-Page"
//                 />

//                 <Route
//                   exact
//                   path="/profile"
//                   element={<ProfilePage />}
//                   title="Profile-Page"
//                 />

//                 <Route
//                   exact
//                   path="/add-address"
//                   element={<AddAddressPage />}
//                   title="Add Address-Page"
//                 />

//                 <Route
//                   exact
//                   path="/edit-address"
//                   element={<UpdateAddressPage />}
//                   title="Edit Address-Page"
//                 />

//                 <Route
//                   exact
//                   path="/edit-profile"
//                   element={<UpdateProfilePage />}
//                   title="Edit Profile-Page"
//                 />

//                 <Route
//                   exact
//                   path="/booking"
//                   element={<BookingPage />}
//                   title="Booking-Page"
//                 />

//                 <Route
//                   exact
//                   path="/dashboard"
//                   element={<DashboardPage />}
//                   title="Dashboard-Page"
//                 />

//                 <Route
//                   exact
//                   path="/chats"
//                   element={<ChatPage />}
//                   title="Chats"
//                 />

//                 <Route
//                   exact
//                   path="/change-password"
//                   element={<ChangePasswordPage />}
//                   title="Change-Password-Page"
//                 />

//                 <Route exact path="/jobs" element={<JobsPage />} title="Jobs" />

//                 <Route
//                   exact
//                   path="/job-details"
//                   element={<JobDetailPage />}
//                   title="Jobs"
//                 />

//                 <Route
//                   exact
//                   path="/order"
//                   element={<OrderPage />}
//                   title="Order-Page"
//                 />

//                 <Route
//                   exact
//                   path="/reviews"
//                   element={<ReviewPage />}
//                   title="Review-Page"
//                 />

//                 <Route
//                   exact
//                   path="/add-review"
//                   element={<AddReviewPage />}
//                   title="Add Review-Page"
//                 />

//                 <Route
//                   exact
//                   path="/notification"
//                   element={<NotificationPage />}
//                   title="Notification-Page"
//                 />

//                 <Route
//                   exact
//                   path="/forgot-password"
//                   element={<ForgetPasswordPage />}
//                   title="Forget-Password-Page"
//                 />

//                 <Route
//                   exact
//                   path="/reset-password/:vUniqueCode"
//                   element={<ResetPasswordPage />}
//                   title="Reset-Password-Page"
//                 />

//                 <Route
//                   exact
//                   path="/check-availability-form"
//                   element={<CheckAvailabilityForm />}
//                   title="Check-Availability-Form"
//                 />

//                 <Route
//                   exact
//                   path="/frequently-asked-questions"
//                   element={<FaqPage />}
//                   title="FAQ-Page"
//                 />
//                 <Route
//                   exact
//                   path="/join-us"
//                   element={<JoinNowPage />}
//                   title="Join-Now-Page"
//                 />

//                 <Route
//                   exact
//                   path="/contractor-application"
//                   element={<ContractorRegisterPage />}
//                   title="Contractor-Application-Page"
//                 />
//                 <Route
//                   exact
//                   path="/services"
//                   element={<ServicesPage />}
//                   title="Service-Page"
//                 />

//                 <Route
//                   exact
//                   path="/move-out-move-in-clean"
//                   element={<MoveInMoveOutPage />}
//                   title="Move In/Move Out-Page"
//                 />

//                 <Route
//                   exact
//                   path="/service-detail/move-out-move-in-clean"
//                   element={<MoveInMoveOutApp />}
//                   title="Move In/Move Out-Page"
//                 />

//                 <Route
//                   exact
//                   path="/deep-cleaning"
//                   element={<DeepCleansPage />}
//                   title="Deep Cleaning-Page"
//                 />

//                 <Route
//                   exact
//                   path="/service-detail/deep-cleaning"
//                   element={<DeepCleaningApp />}
//                   title="Deep Cleaning-Page"
//                 />

//                 <Route
//                   exact
//                   path="/post-event-cleanup"
//                   element={<PostEventCleanupPage />}
//                   title="Post Event Cleanup-Page"
//                 />

//                 <Route
//                   exact
//                   path="/service-detail/post-event-cleanup"
//                   element={<PostEventCleanupApp />}
//                   title="Post Event Cleanup-Page"
//                 />

//                 <Route
//                   exact
//                   path="/routine-clean"
//                   element={<RoutineOneTimeCleaningPage />}
//                   title="Routine OneTime Cleaning-Page"
//                 />

//                 <Route
//                   exact
//                   path="/service-detail/routine-clean"
//                   element={<RoutineCleaningApp />}
//                   title="Routine Cleaning-Page"
//                 />

//                 <Route
//                   exact
//                   path="/success-registration"
//                   element={<SuccessfullRegistrationPage />}
//                   title="Successfulregistration-page"
//                 />
//                 <Route
//                   exact
//                   path="/account-activation/:vUniqueCode"
//                   element={<AccountActivationPage />}
//                   title="accountactivation-page"
//                 />

//                 <Route
//                   exact
//                   path="/account-verified"
//                   element={<AccountVerifiedPage />}
//                   title="Accountverified-page"
//                 />
//                 <Route
//                   exact
//                   path="/success-reset-password"
//                   element={<SuccessResetPasswordPage />}
//                   title="Success-reset-password-page"
//                 />

//                 <Route
//                   exact
//                   path="/logout"
//                   element={<LogoutPage />}
//                   title="Logout"
//                 />

//                 <Route
//                   exact
//                   path="/service-detail/:vServiceName"
//                   element={<ServiceDetailPage />}
//                   title="Service Detail-page"
//                 />
//                 <Route
//                   exact
//                   path="/error"
//                   element={<ErrorPage />}
//                   title="Error-page"
//                 />

//                 <Route
//                   exact
//                   path="/book-now"
//                   element={<BookNowPage />}
//                   title="Book Now-Page"
//                 />

//                 <Route
//                   exact
//                   path="/commercial"
//                   element={<MapforceCommercialPage />}
//                   title="Commercial-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-edmonton"
//                   element={<JobDescriptionPage />}
//                   title="Job Descriptoion-Page "
//                 />

//                 <Route
//                   exact
//                   path="/careers"
//                   element={<CareersPage />}
//                   title="Careers-Page "
//                 />

//                 <Route
//                   exact
//                   path="/blogs"
//                   element={<BlogPage />}
//                   title="Blog-Page "
//                 />

//                 <Route
//                   exact
//                   path="/services"
//                   element={<ServicesPage />}
//                   title="Services-Page "
//                 />
//                 <Route
//                   exact
//                   path="/blog-detail/:vSlug"
//                   // path="/blog-detail"
//                   element={<BlogDetailPage />}
//                   title="Blog Detail-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-calgary"
//                   element={<JobsCalgaryPage />}
//                   title="Jobs Calgary-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-lower-mainland"
//                   element={<JobsLowerMainlandPage />}
//                   title="Job Slower Mainland-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-winnipeg"
//                   element={<JobsWinnipegPage />}
//                   title="Job Winnipeg-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-ottawa"
//                   element={<JobsOttawaPage />}
//                   title="Job Ottawa-Page "
//                 />

//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-toronto"
//                   element={<JobTorontoPage />}
//                   title="Job toronto-Page "
//                 />
//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-mississauga"
//                   element={<JobMississaugaPage />}
//                   title="Job Mississauga-Page "
//                 />
//                 <Route
//                   exact
//                   path="/house-cleaner-jobs-brampton"
//                   element={<JobBramptonPage />}
//                   title="Job Brampton-Page "
//                 />

//                 {/* {(thankYouPageShowHome || thankYouPageShowBookNow) && ( */}
//                 <Route
//                   exact
//                   path="/thank-you"
//                   element={<ThankYouPage />}
//                   title="Thank You-Page "
//                 />

//                 <Route
//                   exact
//                   path="*"
//                   element={<NotFoundPage />}
//                   title="Data Not Found-Page "
//                 />
//               </Routes>
//             )}
//           </Suspense>
//         </>
//       )}
//     </React.Fragment>
//   );
// };

// export default AppWrapper;


import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import { useBookNowClearSessionOnNavigation } from "../components/BookNow/BookFormOne";
import { useClearSessionOnNavigation } from "../components/Home/HomeContact";
import { getMetaDetailList } from "../store/Slice/metaDetailsSlice";
// import Preloader from "../components/Preloader/Preloader";
import { Provider } from "react-redux";

// import ChatbaseWidget from "../components/Common/ChatBaseWidget";
import { store } from "../store/store";
import ChatbaseWidget from "../components/Common/ChatBaseWidget";
import ThankYouPage from "../pages/ThankYouPage";

// const HomePage = React.lazy(() => import("../pages/HomePage"));
import HomePage from "../pages/HomePage";
import BlogDetailPage from "../pages/BlogDetailPage";

import BlogPage from "../pages/BlogPage";
import PasswordPrompt from "../components/PassWord/PasswordPrompt";
import JobsWinnipegPage from "../pages/JobsWinnipegPage";
import JobsOttawaPage from "../pages/JobsOttawaPage";
import JobTorontoPage from "../pages/JobTorontoPage";
import JobMississaugaPage from "../pages/JobMississaugaPage";
import JobBramptonPage from "../pages/JobBramptonPage";
import UpdateProfilePage from "../pages/UpdateProfilePage";
import AddAddressPage from "../pages/AddAddressPage";
import UpdateAddressPage from "../pages/UpdateAddressPage";
import JobDetailPage from "../pages/JobDetailPage";
import AddReviewPage from "../pages/AddReviewPage";
import { setIsNotFound } from "../store/Slice/pageNotFoundSlice";

import PostEventCleanupApp from "../components/MobileApp/Service-Detail/PostEventCleanupApp";
import DeepCleaningApp from "../components/MobileApp/Service-Detail/DeepCleaningApp";
import RoutineCleaningApp from "../components/MobileApp/Service-Detail/RoutineCleaningApp";
import MoveInMoveOutApp from "../components/MobileApp/Service-Detail/MoveInMoveOutApp";
import TermsConditionApp from "../components/MobileApp/TermsAndConditions/TermsConditionApp";
import LandingPage from "../pages/LandingPage";

const LoginPage = React.lazy(() => import("../pages/LoginPage"));
const RegisterPage = React.lazy(() => import("../pages/RegisterPage"));
const ContactPage = React.lazy(() => import("../pages/ContactPage"));
const AboutUsPage = React.lazy(() => import("../pages/AboutUsPage"));
const TermsOfUsePage = React.lazy(() => import("../pages/TermsOfUsePage"));
const PrivacyPolicyPage = React.lazy(() =>
  import("../pages/PrivacyPolicyPage")
);
const ProfilePage = React.lazy(() => import("../pages/ProfilePage"));
const BookingPage = React.lazy(() => import("../pages/BookingPage"));
const DashboardPage = React.lazy(() => import("../pages/DashboardPage"));
const ChatPage = React.lazy(() => import("../pages/ChatPage"));
const ChangePasswordPage = React.lazy(() =>
  import("../pages/ChangePasswordPage")
);
const OrderPage = React.lazy(() => import("../pages/OrderPage"));
const ReviewPage = React.lazy(() => import("../pages/ReviewPage"));
const NotificationPage = React.lazy(() => import("../pages/NotificationPage"));
const ForgetPasswordPage = React.lazy(() =>
  import("../pages/ForgetPasswordPage")
);
const ResetPasswordPage = React.lazy(() =>
  import("../pages/ResetPasswordPage")
);
const CheckAvailabilityForm = React.lazy(() =>
  import("../pages/CheckAvailabilityForm")
);
const FaqPage = React.lazy(() => import("../pages/FaqPage"));
const JoinNowPage = React.lazy(() => import("../pages/JoinNowPage"));
const ContractorRegisterPage = React.lazy(() =>
  import("../pages/ContractorRegisterPage")
);

const ServicesPage = React.lazy(() => import("../pages/ServicesPage"));
const MoveInMoveOutPage = React.lazy(() =>
  import("../pages/MoveInMoveOutPage")
);
const DeepCleansPage = React.lazy(() => import("../pages/DeepCleansPage"));
const PostEventCleanupPage = React.lazy(() =>
  import("../pages/PostEventCleanupPage")
);
const RoutineOneTimeCleaningPage = React.lazy(() =>
  import("../pages/RoutineOneTimeCleaningPage")
);
const JobsPage = React.lazy(() => import("../pages/JobsPage"));
const SuccessfullRegistrationPage = React.lazy(() =>
  import("../pages/SuccessfullRegistrationPage")
);
const AccountActivationPage = React.lazy(() =>
  import("../pages/AccountActivationPage")
);
const AccountVerifiedPage = React.lazy(() =>
  import("../pages/AccountVerifiedPage")
);
const SuccessResetPasswordPage = React.lazy(() =>
  import("../pages/SuccessResetPasswordPage")
);
const LogoutPage = React.lazy(() => import("../pages/LogoutPage"));
const ServiceDetailPage = React.lazy(() =>
  import("../pages/ServiceDetailPage")
);
const ErrorPage = React.lazy(() => import("../pages/ErrorPage"));
const BookNowPage = React.lazy(() => import("../pages/BookNowPage"));

const MapforceCommercialPage = React.lazy(() =>
  import("../pages/MapforceCommercialPage")
);
const JobDescriptionPage = React.lazy(() =>
  import("../pages/JobDescriptionPage")
);
const CareersPage = React.lazy(() => import("../pages/CareersPage"));
const JobsCalgaryPage = React.lazy(() => import("../pages/JobsCalgaryPage"));
const JobsLowerMainlandPage = React.lazy(() =>
  import("../pages/JobsLowerMainlandPage")
);
const NotFoundPage = React.lazy(() => import("../pages/NotFoundPage"));

function AppWrapper() {
  return (
    <Provider store={store}>
      <Index />
    </Provider>
  );
}

const Index = () => {
  // ============ ALL HOOKS MUST BE CALLED FIRST ============
  // All useState, useEffect, useSelector, useDispatch, etc. must be at the top
  const dispatch = useDispatch();
  const location = useLocation();

  // Redirect state
  const [isRedirecting, setIsRedirecting] = React.useState(true);
  
  // Your existing states
  const [isPasswordCorrect, setIsPasswordCorrect] = React.useState(false);
  const [isAuthChecked, setIsAuthChecked] = React.useState(false);

  const { metaDetailData } = useSelector((state) => state.metaDetailList);

  // Custom hooks
  useClearSessionOnNavigation();
  useBookNowClearSessionOnNavigation();

  // ============ REDIRECT EFFECT ============
  React.useEffect(() => {
    // Get current URL details
    const currentHost = window.location.hostname;
    const currentProtocol = window.location.protocol;
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;
    
    // Development domains - skip redirect
    const devDomains = ['localhost', '127.0.0.1', '.local', '.test', 'mopforce.demo-available.com'];
    const isDevDomain = devDomains.some(domain => currentHost.includes(domain));
    
    // Your main domain that needs www
    const mainDomain = 'mopforce.com';
    
    // Skip redirect for development
    if (isDevDomain) {
      setIsRedirecting(false);
      return;
    }
    
    // Check if we need to redirect
    let redirectUrl = null;
    
    // 1. Redirect non-www to www for main domain
    if (currentHost === mainDomain) {
      redirectUrl = `https://www.${mainDomain}${currentPath}${currentSearch}${currentHash}`;
    }
    // 2. Redirect HTTP to HTTPS (if not already HTTPS)
    else if (currentProtocol !== 'https:' && currentHost.includes('mopforce.com')) {
      redirectUrl = `https://${currentHost}${currentPath}${currentSearch}${currentHash}`;
    }
    // 3. If already on www with HTTPS, no redirect needed
    else {
      setIsRedirecting(false);
      return;
    }
    
    // Perform the redirect if needed
    if (redirectUrl) {
      console.log('Redirecting to:', redirectUrl); // For debugging
      window.location.replace(redirectUrl);
      // Don't set isRedirecting to false as we're leaving the page
      return;
    }
    
    setIsRedirecting(false);
  }, []); // Empty dependency array - run once on mount

  // ============ YOUR EXISTING EFFECTS ============
  const pageUrlSlug =
    location && location.pathname && location.pathname.split("/")[1];

  const pathWithoutSlash = location && location.pathname.slice(1);

  const vpath = location.pathname === "/" ? "Home" : pathWithoutSlash;

  const formattedTitle = vpath.charAt(0).toLowerCase() + vpath.slice(1);

  const path = location.pathname;
  const blockedDomain = "mopforce.com";
  // const blockedDomain = "localhost";
  const currentDomain = window.location.hostname;

  const normalizedDomain = currentDomain?.replace(/\/$/, "");
  const normalizedBlockedDomain = blockedDomain?.replace(/\/$/, "");

  const normalizedPath = path?.split("?")[0]?.replace(/\/$/, "");

  const checkLiveDomain =
    normalizedDomain === normalizedBlockedDomain &&
    (normalizedPath === "/login" || normalizedPath === "/register");

  React.useEffect(() => {
    if (checkLiveDomain) {
      dispatch(getMetaDetailList({ vSlug: "page-not-found" }));
    } else {
      dispatch(setIsNotFound(false)); // ensure reset on valid routes
      dispatch(getMetaDetailList({ vSlug: pageUrlSlug || formattedTitle }));
    }
  }, [dispatch, pageUrlSlug, formattedTitle, checkLiveDomain]);

  React.useEffect(() => {
    if (location?.pathname === "/frequently-asked-questions") {
    } else {
      sessionStorage.removeItem("faqUserType");
      sessionStorage.removeItem("viewAllButtonClick");
    }
  }, [location]);

  const ScrollToTopOnRouteChange = () => {
    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return null;
  };

  React.useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("mopforce_auth");
    if (isAuthenticated === "true") {
      setIsPasswordCorrect(true);
    }
    setIsAuthChecked(true);
  }, []);

  const handlePasswordCorrect = (status) => {
    if (status) {
      sessionStorage.setItem("mopforce_auth", "true");
    }
    setIsPasswordCorrect(status);
  };

  // ============ CONDITIONAL RENDERING ============
  // Show nothing while checking redirect
  if (isRedirecting) {
    return null;
  }

  if (!isAuthChecked) {
    return null;
  }

  return (
    <React.Fragment>
      {!isPasswordCorrect && currentDomain === "mopforce.demo-available.com" ? (
        <PasswordPrompt onPasswordCorrect={handlePasswordCorrect} />
      ) : (
        <>
          <Helmet>
            <title>
              {metaDetailData?.data?.vTitle
                ? `${metaDetailData?.data?.vTitle} | MopForce`
                : "MopForce"}
            </title>
            <meta
              name="description"
              content={
                metaDetailData?.data?.tDescription ||
                "Professional cleaning services by MopForce."
              }
            />
            <meta
              name="keywords"
              content={
                metaDetailData?.data?.tKeyword ||
                "cleaning, housekeeping, MopForce"
              }
            />
            <meta
              property="og:title"
              content={
                metaDetailData?.data?.vTitle
                  ? `${metaDetailData?.data?.vTitle} | MopForce`
                  : "MopForce"
              }
            />
            <meta
              property="og:description"
              content={
                metaDetailData?.data?.tDescription ||
                "Professional cleaning services by MopForce."
              }
            />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:type" content="website" />
          </Helmet>

          <ScrollToTopOnRouteChange />

          <ChatbaseWidget />

          <Suspense
            fallback={
              null
              // <div>Loading...</div>
              //   <Preloader />
            }
          >
            {checkLiveDomain ? (
              <NotFoundPage />
            ) : (
              <Routes>
                <Route
                  exact
                  path="/"
                  element={<HomePage />}
                  title="Home-Page"
                />

                <Route
                  exact
                  path="/login"
                  element={<LoginPage />}
                  title="Login-Page"
                />

                <Route
                  exact
                  path="/register"
                  element={<RegisterPage />}
                  title="Register-Page"
                />

                <Route
                  exact
                  path="/:pageSlug"
                  element={<LandingPage />}
                />

                <Route
                  exact
                  path="/contact-us"
                  element={<ContactPage />}
                  title="Contact-Us-Page"
                />
                <Route
                  exact
                  path="/about-us"
                  element={<AboutUsPage />}
                  title="About-Us-Page"
                />

                <Route
                  exact
                  path="/terms-and-conditions"
                  element={<TermsOfUsePage />}
                  title="Terms-and-Conditions-Page"
                />

                <Route
                  exact
                  path="/help-and-legal/terms-and-conditions"
                  element={<TermsConditionApp />}
                  title="Terms-and-Conditions-Page"
                />

                <Route
                  exact
                  path="/privacy-policy"
                  element={<PrivacyPolicyPage />}
                  title="Privacy-Policy-Page"
                />

                <Route
                  exact
                  path="/profile"
                  element={<ProfilePage />}
                  title="Profile-Page"
                />

                <Route
                  exact
                  path="/add-address"
                  element={<AddAddressPage />}
                  title="Add Address-Page"
                />

                <Route
                  exact
                  path="/edit-address"
                  element={<UpdateAddressPage />}
                  title="Edit Address-Page"
                />

                <Route
                  exact
                  path="/edit-profile"
                  element={<UpdateProfilePage />}
                  title="Edit Profile-Page"
                />

                <Route
                  exact
                  path="/booking"
                  element={<BookingPage />}
                  title="Booking-Page"
                />

                <Route
                  exact
                  path="/dashboard"
                  element={<DashboardPage />}
                  title="Dashboard-Page"
                />

                <Route
                  exact
                  path="/chats"
                  element={<ChatPage />}
                  title="Chats"
                />

                <Route
                  exact
                  path="/change-password"
                  element={<ChangePasswordPage />}
                  title="Change-Password-Page"
                />

                <Route exact path="/jobs" element={<JobsPage />} title="Jobs" />

                <Route
                  exact
                  path="/job-details"
                  element={<JobDetailPage />}
                  title="Jobs"
                />

                <Route
                  exact
                  path="/order"
                  element={<OrderPage />}
                  title="Order-Page"
                />

                <Route
                  exact
                  path="/reviews"
                  element={<ReviewPage />}
                  title="Review-Page"
                />

                <Route
                  exact
                  path="/add-review"
                  element={<AddReviewPage />}
                  title="Add Review-Page"
                />

                <Route
                  exact
                  path="/notification"
                  element={<NotificationPage />}
                  title="Notification-Page"
                />

                <Route
                  exact
                  path="/forgot-password"
                  element={<ForgetPasswordPage />}
                  title="Forget-Password-Page"
                />

                <Route
                  exact
                  path="/reset-password/:vUniqueCode"
                  element={<ResetPasswordPage />}
                  title="Reset-Password-Page"
                />

                <Route
                  exact
                  path="/check-availability-form"
                  element={<CheckAvailabilityForm />}
                  title="Check-Availability-Form"
                />

                <Route
                  exact
                  path="/frequently-asked-questions"
                  element={<FaqPage />}
                  title="FAQ-Page"
                />
                <Route
                  exact
                  path="/join-us"
                  element={<JoinNowPage />}
                  title="Join-Now-Page"
                />

                <Route
                  exact
                  path="/contractor-application"
                  element={<ContractorRegisterPage />}
                  title="Contractor-Application-Page"
                />
                <Route
                  exact
                  path="/services"
                  element={<ServicesPage />}
                  title="Service-Page"
                />

                <Route
                  exact
                  path="/move-out-move-in-clean"
                  element={<MoveInMoveOutPage />}
                  title="Move In/Move Out-Page"
                />

                <Route
                  exact
                  path="/service-detail/move-out-move-in-clean"
                  element={<MoveInMoveOutApp />}
                  title="Move In/Move Out-Page"
                />

                <Route
                  exact
                  path="/deep-cleaning"
                  element={<DeepCleansPage />}
                  title="Deep Cleaning-Page"
                />

                <Route
                  exact
                  path="/service-detail/deep-cleaning"
                  element={<DeepCleaningApp />}
                  title="Deep Cleaning-Page"
                />

                <Route
                  exact
                  path="/post-event-cleanup"
                  element={<PostEventCleanupPage />}
                  title="Post Event Cleanup-Page"
                />

                <Route
                  exact
                  path="/service-detail/post-event-cleanup"
                  element={<PostEventCleanupApp />}
                  title="Post Event Cleanup-Page"
                />

                <Route
                  exact
                  path="/routine-clean"
                  element={<RoutineOneTimeCleaningPage />}
                  title="Routine OneTime Cleaning-Page"
                />

                <Route
                  exact
                  path="/service-detail/routine-clean"
                  element={<RoutineCleaningApp />}
                  title="Routine Cleaning-Page"
                />

                <Route
                  exact
                  path="/success-registration"
                  element={<SuccessfullRegistrationPage />}
                  title="Successfulregistration-page"
                />
                <Route
                  exact
                  path="/account-activation/:vUniqueCode"
                  element={<AccountActivationPage />}
                  title="accountactivation-page"
                />

                <Route
                  exact
                  path="/account-verified"
                  element={<AccountVerifiedPage />}
                  title="Accountverified-page"
                />
                <Route
                  exact
                  path="/success-reset-password"
                  element={<SuccessResetPasswordPage />}
                  title="Success-reset-password-page"
                />

                <Route
                  exact
                  path="/logout"
                  element={<LogoutPage />}
                  title="Logout"
                />

                <Route
                  exact
                  path="/service-detail/:vServiceName"
                  element={<ServiceDetailPage />}
                  title="Service Detail-page"
                />
                <Route
                  exact
                  path="/error"
                  element={<ErrorPage />}
                  title="Error-page"
                />

                <Route
                  exact
                  path="/book-now"
                  element={<BookNowPage />}
                  title="Book Now-Page"
                />

                <Route
                  exact
                  path="/commercial"
                  element={<MapforceCommercialPage />}
                  title="Commercial-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-edmonton"
                  element={<JobDescriptionPage />}
                  title="Job Descriptoion-Page "
                />

                <Route
                  exact
                  path="/careers"
                  element={<CareersPage />}
                  title="Careers-Page "
                />

                <Route
                  exact
                  path="/blogs"
                  element={<BlogPage />}
                  title="Blog-Page "
                />

                <Route
                  exact
                  path="/services"
                  element={<ServicesPage />}
                  title="Services-Page "
                />
                <Route
                  exact
                  path="/blog-detail/:vSlug"
                  // path="/blog-detail"
                  element={<BlogDetailPage />}
                  title="Blog Detail-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-calgary"
                  element={<JobsCalgaryPage />}
                  title="Jobs Calgary-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-lower-mainland"
                  element={<JobsLowerMainlandPage />}
                  title="Job Slower Mainland-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-winnipeg"
                  element={<JobsWinnipegPage />}
                  title="Job Winnipeg-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-ottawa"
                  element={<JobsOttawaPage />}
                  title="Job Ottawa-Page "
                />

                <Route
                  exact
                  path="/house-cleaner-jobs-toronto"
                  element={<JobTorontoPage />}
                  title="Job toronto-Page "
                />
                <Route
                  exact
                  path="/house-cleaner-jobs-mississauga"
                  element={<JobMississaugaPage />}
                  title="Job Mississauga-Page "
                />
                <Route
                  exact
                  path="/house-cleaner-jobs-brampton"
                  element={<JobBramptonPage />}
                  title="Job Brampton-Page "
                />

                <Route
                  exact
                  path="/thank-you"
                  element={<ThankYouPage />}
                  title="Thank You-Page "
                />

                <Route
                  exact
                  path="*"
                  element={<NotFoundPage />}
                  title="Data Not Found-Page "
                />
              </Routes>
            )}
          </Suspense>
        </>
      )}
    </React.Fragment>
  );
};

export default AppWrapper;